<template>
  <v-tour
    class="onboarding-tour"
    :name="name"
    :options="options"
    :steps="steps"
    :callbacks="callbacks"
  />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      callbacks: {
        onStart: step => this.$emit('start', step),
        onPreviousStep: step => this.$emit('prev', step),
        onNextStep: step => this.$emit('next', step),
        onSkip: step => this.$emit('skip', step),
        onFinish: step => this.$emit('finish', step),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.onboarding-tour ::v-deep .v-step {
  min-width: 230px;
  max-width: 300px;
  border-radius: 0;
  background: blue(900) !important;

  .v-step__header {
    border-radius: 0;
    color: blue(100);
    background: blue(600);
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .v-step__arrow::before {
    background: blue(600);
  }

  .v-step__button {
    height: unset;
    padding: 6px 12px;
    border: 0;
    border-radius: 0;
    color: blue(100);
    background: blue(600);
    font-weight: 600;

    &:hover {
      color: blue(100);
      background: blue(700);
    }
  }
}

</style>
